import * as types from './mutation-types'

export default {

  [types.ADD_CATEGORIES](state, categories) {
    state.categories = categories.data
    state.meta_data = categories.meta
  }
}
